import React from 'react';
import { Upload, X, ChevronRight } from 'lucide-react';
import type { Creation } from '../../types/create';

interface UploadImageProps {
  uploadedImagePreview: string | null;
  selectedCreation: Creation | undefined;
  isHistoryMode: boolean;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearImage: () => void;
  onContinue: () => void;
}

export const UploadImage: React.FC<UploadImageProps> = ({
  uploadedImagePreview,
  selectedCreation,
  isHistoryMode,
  onFileChange,
  onClearImage,
  onContinue
}) => {
  const displayImage = isHistoryMode && selectedCreation?.originalImageUrl 
    ? selectedCreation.originalImageUrl 
    : uploadedImagePreview;

  return (
    <div className="flex flex-col items-center justify-center h-full py-12 text-center">
      {displayImage ? (
        <div className="mb-6 relative">
          <img 
            src={displayImage} 
            alt="Preview" 
            className="max-h-64 rounded-lg shadow-md" 
          />
          {!isHistoryMode && (
            <button
              onClick={onClearImage}
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 shadow-sm"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      ) : (
        <>
          <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-6">
            <Upload className="w-8 h-8 text-gray-400" />
          </div>
          <h3 className="text-xl font-bold mb-2">Upload Your Photo</h3>
          <p className="text-gray-500 mb-6 max-w-md">Select a high-quality photo to transform. We support JPG and PNG formats.</p>
        </>
      )}
      
      <input 
        type="file" 
        id="image-upload" 
        className="hidden" 
        accept="image/*"
        onChange={onFileChange}
        disabled={isHistoryMode}
      />
      
      {!displayImage ? (
        <button 
          onClick={() => document.getElementById('image-upload')?.click()}
          className="bg-black text-white px-6 py-3 md:px-8 md:py-4 rounded-lg hover:bg-gray-800 transition-colors min-h-[48px] touch-manipulation"
        >
          Choose File
        </button>
      ) : (
        <button 
          onClick={onContinue}
          className="bg-black text-white px-6 md:px-8 py-3 md:py-4 rounded-lg hover:bg-gray-800 transition-colors flex items-center gap-2 min-h-[48px] touch-manipulation"
        >
          Continue to Style Selection
          <ChevronRight className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

